module.exports = __webpack_public_path__ + "a8c874b93b3d848f39a71260c57e3863.cur";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/media_control/public/closed-hand.cur
 ** module id = 47
 ** module chunks = 0
 **/